import { customEvent } from "../modules/tracking/AnalyticsEvents";

export default class {
    constructor(options) {
        // The target as a DOM object
        this.target = false;
        // The target as a jQuery object
        this.targetJquery = false;
        // This is for the parent form element
        this.form = false;
        // The element tag name e.g. select for <select>
        this.tagName = false;
        // The element input type e.g. text/password/email etc
        this.inputType = false;
        // Array of messages to show on validation
        this.messages = {
            error: [],
            warning: [],
            info: [],
        };

        // classes for validation
        this.classes = {
            error: 'bg-danger',
            warning: 'bg-warning',
            info: 'bg-info',
            animationIn: 'slideInDown',
            animationOut: 'slideOutUp',
            valid: 'inputValid',
            invalid: 'inputError',
            newInvalid: 'new_inputError'
        };

        // Holds any custom validation methods
        this.custom = [];

        if (typeof options == 'undefined') {
            return;
        }

        if (typeof options.form !== 'undefined') {
            this.form = options.form;
            this.classes = this.form.classes;
            this.custom = this.form.custom;
        }

        // Pass in any custom validation methods
        if (typeof options.custom !== 'undefined') {
            this.custom = options.custom;
        }

        if (typeof options.target !== 'undefined' && document.querySelector(options.target)) {
            this.target = document.querySelector(options.target);
            this.targetJquery = $(this.target);
        }

        if (typeof options.element !== 'undefined') {
            this.target = options.element;
            this.targetJquery = $(options.element);
        }

        if (typeof options.classes !== 'undefined') {
            Object.keys(options.classes).forEach(key => {
                this.classes[key] = options.classes[key];
            });
        }

        this.setTagName();
        this.setInputType();
    }

    clearMessages() {
        this.messages = {
            error: [],
            warning: [],
            info: [],
        };
    }

    getTagName(el) {
        let target = this.target;
        if (typeof el !== 'undefined') {
            target = el;
        }
        if (typeof target.tagName !== 'undefined') {
            return target.tagName.toLowerCase();
        }
        return false;
    }

    setTagName() {
        return this.tagName = this.getTagName();
    }

    getInputType(el) {
        let target = this.target;
        if (typeof el !== 'undefined') {
            target = el;
        }
        if (target.getAttribute('type') !== null) {
            return target.getAttribute('type').toLowerCase();
        }
        return false;
    }

    setInputType() {
        return this.inputType = this.getInputType();
    }

    // Recursive function that will navigate up the parents of the elements up to depthToCheck times, trying to find a .form-group
    checkForParentFormGroup(element, depthToCheck) {
        let formGroup = element.parentNode;
        if (!formGroup) {
            return false;
        }
        if (formGroup.classList.contains('form-group')) {
            return formGroup;
        }
        if (depthToCheck >= 1) {
            return this.checkForParentFormGroup(formGroup, depthToCheck - 1);
        }
        return false;
    }

    // Recursive function to navigate up the parents of the elements until a certain depth is reached
    getElementFromDepth(element, depthToCheck) {
        let parentElement = element.parentNode;
        if (!parentElement) {
            return element;
        }
        if (depthToCheck >= 1) {
            return this.getElementFromDepth(parentElement, depthToCheck - 1);
        }
        return parentElement;
    }

    getErrorMessageIdForElement(type) {
        return this.form.uuid + this.target.getAttribute('name') + '-' + type + '-Message';
    }

    removeErrorMessages() {
        Object.keys(this.messages).forEach(type => {
            const elements = document.querySelectorAll('#' + this.getErrorMessageIdForElement(type));
            if (elements.length <= 0) {
                return;
            }
            elements.forEach(element => {
                if (this.form.reskin) {
                    const parentNode = element.parentNode;
                    if (parentNode) {
                        parentNode.removeChild(element);
                    }
                    return;
                }
                element.addEventListener('animationend', (test) => {
                    const parentNode = element.parentNode;
                    if (parentNode) {
                        parentNode.removeChild(element);
                    }
                });
                // element.classList.remove('slideInDown');
                element.classList.add(this.classes.animationOut);
            });
        });
    }

    renderMessages() {
        if (this.getEventType() == 'input' && this.target === document.activeElement) {
            return false;
        }
        let target = false;

        // If the element has a data-error-target attribute, then use that as the target, if it exists
        const errorTarget = this.target.dataset.errorTarget;
        if (errorTarget && document.querySelector('#' + errorTarget)) {
            target = document.querySelector('#' + errorTarget);
        }

        // If we have a data-error-parent-level on the element, then get the target that's that many parents up
        if (target == false && this.target.dataset.errorParentLevel) {
            target = this.getElementFromDepth(this.target, this.target.dataset.errorParentLevel);
        }
        if (target == false && this.form.reskin) {
            target = this.targetJquery.parents('.material-form__field').first()[0];
        }
        // If we don't have a specific error target element so far
        // Check if element has a form-group around it, and if so, use it as error target
        if (target == false) {
            target = this.checkForParentFormGroup(this.target, 3);
        }
        // Failing that, use this element as the target
        if (target == false) {
            target = this.target;
        }
        // And failing that somehow?? use the form
        if (target == false) {
            target = this.form.getForm()[0];
        }
        // Or just give up
        if (target == false) {
            return false;
        }

        // If we don't show errors for this element, remove any errors and give up
        if (target.dataset.hideError) {
            this.removeErrorMessages();
            return true;
        }


        // Cycle through each this.messages type, adding the class accordingly
        Object.keys(this.messages).forEach(type => {
            const messages = this.messages[type];
            if (typeof messages !== 'object' || messages.length <= 0) {
                return;
            }

            messages.forEach(message => {
                // Check if the validation error target exists already
                let id = this.getErrorMessageIdForElement(type);
                let errorElement = document.querySelector('#' + id);
                if (errorElement) {
                    errorElement.innerHTML = message;
                    return;
                }

                // Sometimes the target has validation errors in it already, like with title/first/last name. In this case, we want to move the target to the last one of those
                let existingErrors = target.querySelectorAll('.validation-error');
                if (existingErrors.length > 0) {
                    target = existingErrors[existingErrors.length - 1];
                }

                let newErrorElement = document.createElement('div');

                if (this.form.getForm()[0].dataset.isNewForm === '1') {
                    newErrorElement.classList.add('new-error-message');
                } else {
                    newErrorElement.classList.add(this.classes[type]);
                }

                if (this.target.dataset.errorClass) {
                    newErrorElement.classList.add(this.target.dataset.errorClass);
                } else {
                    newErrorElement.classList.add('validation-error');
                }

                newErrorElement.classList.add('animated');
                newErrorElement.classList.add(this.classes.animationIn);
                newErrorElement.setAttribute('id', id);
                newErrorElement.innerText = message;

                target.parentNode.insertBefore(newErrorElement, target.nextSibling);
                return;
            });
        });
    }

    getErrorMessage() {
        if (this.target.dataset.validateMessage) {
            return this.target.dataset.validateMessage;
        }
        if (this.tagName == 'select') {
            return 'Please select an option';
        }
        if (this.inputType == 'radio') {
            return 'Please select an option';
        }
        if (this.inputType == 'checkbox') {
            return 'Please tick an option';
        }
        if (this.inputType == 'email') {
            return 'Please enter an email address';
        }
        if (this.inputType == 'tel') {
            return 'Please enter a telephone number';
        }
        if (this.inputType == 'password') {
            return 'Please enter a password';
        }
        if (this.inputType == 'file') {
            return 'Please select a file';
        }

        return 'Please fill in this field';
    }

    addMessage(type, message) {
        // If the message isn't a string, is empty, or the type isn't valid, do nothign
        if (typeof message !== 'string' ||
            message == '' ||
            typeof this.messages[type] == 'undefined') {
            return false;
        }

        // Else push the message onto the relevant queue
        this.messages[type].push(message);
        return true;
    }

    clearValidation() {
        this.clearMessages();
        this.target.classList.remove(this.classes.invalid);
        this.target.classList.remove(this.classes.valid);
        this.target.classList.remove(this.classes.newInvalid);
    }

    setToValid() {
        // Don't add any classes if data-hide-error is set
        if (this.target.dataset.hideError) {
            return true;
        }


        // Add the valid class to the element, if it's an actual input element
        if (this.getEventType() !== false && !this.form.getForm()[0].dataset.isNewForm) {
            this.target.classList.add(this.classes.valid);
        }

        // Remove this elements messages
        this.removeErrorMessages();
        return true;
    }

    setToInvalid() {
        // Don't add any classes if data-hide-error is set
        if (this.target.dataset.hideError) {
            return true;
        }

        // Don't mark as invalid if in focus
        if (this.target === document.activeElement && this.target === document.activeElement) {
            return false;
        }


        // Add the invalid class to the element, if it's an actual input element
        if (this.getEventType() !== false) {
            if(this.form.getForm()[0].dataset.isNewForm === '1') {
                this.target.classList.add(this.classes.newInvalid);
            } else {
                this.target.classList.add(this.classes.invalid);
            }
        }

        this.renderMessages();

        return true;
    }

    // Valid check specifically for data-validate="input"
    isValid_input(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        let defaultValue = '';

        if (toValidate.val() != defaultValue && toValidate.val() != '') {
            return true;
        }

        this.addMessage('error', this.getErrorMessage());

        return false;
    }

    // Validate HTML5 date input (YYYY-MM-DD)
    isValid_date(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }

        const val = (toValidate.val() || '').trim();

        // Allow nullable fields
        if (toValidate.data('nullable') && val === '') {
            return true;
        }

        if (val !== '') {
            // Basic format check
            if (!/^\d{4}-\d{2}-\d{2}$/.test(val)) {
                this.addMessage('error', 'Please enter a valid date (YYYY-MM-DD)');
                return false;
            }

            const parts = val.split('-');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);

            // Create a Date and verify components match (guards against invalid dates like 2025-02-30)
            const dt = new Date(year, month - 1, day);
            if (dt.getFullYear() !== year || dt.getMonth() + 1 !== month || dt.getDate() !== day) {
                this.addMessage('error', 'Please enter a valid calendar date (YYYY-MM-DD)');
                return false;
            }

            return true;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_number(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        let value = toValidate.val();

        // Check if value is not empty and is a valid number
        if (value !== '' && !isNaN(value) && isFinite(value)) {
            return true;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_checkbox(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }

        if (toValidate.is(":checked")) {
            return true;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_radio(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        // Check if this form contains an input with the name that matches this elements name that's checked
        if (this.form.getForm().find("input[name='" + toValidate.attr('name') + "']:checked").val()) {
            return true;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_email(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        let defaultValue = '';

        toValidate.removeClass('inputError').removeClass('inputValid');

        if (toValidate.val() != defaultValue && toValidate.val() != '') {
            // Only mark email as true if it passes isValidEmailAddress too
            if (this.isValidEmailAddress(toValidate.val()) == true) {
                return true;
            }

            this.addMessage('error', 'Please enter a valid email address');
            return false;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_postcode(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        let defaultValue = '';

        toValidate.removeClass('inputError').removeClass('inputValid');

        if (toValidate.val() != defaultValue && toValidate.val() != '') {
            // Only mark postcode as true if it passes isValidPostcode too
            if (this.isValidPostcode(toValidate.val()) == true) {
                return true;
            }

            this.addMessage('error', 'Please enter a valid UK Postcode');
            return false;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_tel(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        // This needs refactoring to be more general, rather than for this element only
        if (toValidate.data('nullable') && toValidate.val() == '') {
            return true;
        }

        if (toValidate.length > 0) {
            let phoneTest = this.isValidPhone(toValidate.val());

            if (phoneTest == true) {
                return true;
            }

            if (phoneTest == 'invalid') {
                this.addMessage('error', 'Telephone number contains an invalid character, please enter a valid telephone number');
                return false;
            }

            if (phoneTest == 'short') {
                this.addMessage('error', 'Telephone number too short, please enter a valid telephone number');
                return false;
            }

            this.addMessage('error', this.getErrorMessage());
            return false;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_select(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        if (toValidate.prop("selectedIndex") > 0) {
            return true;
        }
        if (toValidate.val() !== '' && toValidate.val() !== null) {
            return true;
        }

        this.addMessage('error', this.getErrorMessage());
        return false;
    }

    isValid_fileType(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        let types = toValidate.data('types').split(',');

        if (toValidate.get(0).files.length !== 0) {
            if (types.indexOf(toValidate[0].files[0].type) === -1) {
                this.addMessage('error', this.getErrorMessage());
                return false;
            }
        }
        return true;
    }

    isValid_fileTypeRequired(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }
        // let types = toValidate.data('types').split(',');

        // if (toValidate.get(0).files.length !== 0) {
        //     if (types.indexOf(toValidate[0].files[0].type) === -1) {
        //         this.addMessage('error', this.getErrorMessage());
        //         return false;
        //     }
        // }
        if (toValidate.get(0).files.length === 0) {
            this.addMessage('error', this.getErrorMessage());
            return false;
        }
        return true;
    }

    isValid_password(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }

        if (toValidate.data('validateNullable') && toValidate.val() == '') {
            return true;
        }

        if (toValidate.val() != '' && toValidate.val() != '' && this.isValidPassword(toValidate.val())) {
            return true;
        }

        this.addMessage('error', 'Your password must be at least 8 characters long and contain at least one uppercase/lowercase letters and one number');
        return false;
    }

    isValid_confirm_password(element) {
        let toValidate = this.targetJquery;
        if (typeof element !== 'undefined') {
            toValidate = element;
        }

        const targetElementSelector = toValidate.data('validateConfirmPasswordTarget');
        if (!targetElementSelector) {
            console.error("No data-validate-confirm-password-target on data-validate=\"confirm_password\" element");
            return true;
        }

        const targetToMatch = this.form.formElementOriginal.querySelector(targetElementSelector);
        if (!targetToMatch) {
            console.error("No element was found within this form, using the supplied selector", targetElementSelector, this.form.formElementOriginal);
            return true;
        }

        if (toValidate.val() != '' && toValidate.val() == targetToMatch.value) {
            return true;
        }

        if (toValidate.val() == '' && targetToMatch.value == '' && targetToMatch.dataset.validateNullable) {
            return true;
        }

        this.addMessage('error', 'Please ensure your passwords match');
        return false;
    }

    // Gets all the children in a group
    getGroupElements() {
        let groupToValidate = this.target.dataset.validateGroupTarget;
        if (typeof groupToValidate !== 'undefined' && groupToValidate != '') {
            return this.form.getForm().find('[data-validate-group="' + groupToValidate + '"]');
        }
        return false;
    }

    // Ensures at least 1 of a group are valid i.e. ticked or not empty
    isValid_group() {
        let groupElements = this.getGroupElements();
        let anyChecked = false;
        if (typeof groupElements !== 'undefined' && groupElements !== false) {
            let self = this;
            // Search through the form this element is a part of, to find others in the same validate-group
            groupElements.each(function (index) {
                // See if we have a method called isValid_whatever, and if we have it, then call it to validate the element
                let methodName = $(this).attr('type');
                if (typeof self['isValid_' + methodName] !== 'undefined') {
                    if (self['isValid_' + methodName]($(this)) !== false) {
                        anyChecked = true;
                    }
                }
            });
        }

        if (anyChecked) {
            return true;
        }

        this.addMessage('error', 'Please select at least one option');
        return false;
    }

    handleCustomFailure(response) {
        if (typeof response.message == 'object') {
            // Check if the passed message has a type, and it's a valid type, and the message exists too
            if (typeof response.message.type !== 'undefined' &&
                typeof response.message.message == 'string' &&
                this.messages[response.message.type]) {
                this.addMessage(response.message.type, response.message.message);
                return true;
            }
        }
        // If the response has just a string message, add it as an error
        if (typeof response.message == 'string') {
            this.addMessage('error', response.message);
            return true;
        }

        // Otherwise just mark as a failure
        return false;
    }

    callCustomFunctions() {
        let failedValidation = false;
        // Get the valid-custom attribute contents
        let customFunctions = this.target.getAttribute('valid-custom');
        // Split it into an array with | as the separator
        customFunctions = customFunctions.split("|");
        if (typeof customFunctions != 'object') {
            return false;
        }
        // Iterate over the array of custom validation rules to be called
        Object.keys(customFunctions).forEach(index => {
            const key = customFunctions[index];
            // Call them if they have been passed to the validator constructor with {custom:}
            if (typeof this.custom[key] == 'undefined') {
                return;
            }
            // The actual custom function call
            const customValidationResponse = this.custom[key](this.target);

            // If the response isn't true, then we know it was failed and set the return value accordingly
            if (typeof customValidationResponse != 'undefined' && (customValidationResponse == false || (typeof customValidationResponse.valid !== 'undefined' && customValidationResponse.valid == false))) {
                failedValidation = true;
            }

            // Handle the failed response
            this.handleCustomFailure(customValidationResponse);
        });
        return failedValidation;
    }

    isValid(optionalDisplay) {
        let skipDisplay = false;
        if (typeof optionalDisplay !== 'undefined') {
            skipDisplay = true;
        }
        // Clear any existing validation messages and classes
        this.clearValidation();

        let failedValidation = false;
        let removeErrorMessagesAlreadyCalled = false;
        // See if we have a method called isValid_whatever, and if we have it, then call it to validate the element
        let methodName = this.target.dataset.validate;
        if (typeof this['isValid_' + methodName] !== 'undefined') {
            if (this['isValid_' + methodName]() == false) {
                failedValidation = true;
                if (!skipDisplay) {
                    this.setToInvalid();
                }
            }
        }

        // See if there are any custom validation rules requested
        if (this.target.getAttribute('valid-custom')) {
            failedValidation = this.callCustomFunctions();
            if (failedValidation) {
                this.setToInvalid();
            }
        }

        if (!skipDisplay && failedValidation == true) {
            this.renderMessages();
            return false;
        } else if (!skipDisplay && !failedValidation) {
            this.setToValid();
            removeErrorMessagesAlreadyCalled = true;
        }

        if (!removeErrorMessagesAlreadyCalled) {
            this.removeErrorMessages();
        }
        return true;
    }

    isValidEmailAddress(emailAddress) {
        let pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
        return pattern.test(emailAddress);
    }

    isValidPostcode(postcode) {
        // let pattern = new RegExp(/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/i);
        let pattern = /^([A-Za-z][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][0-9][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][0-9][A-Za-z][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][A-Za-z][ ]*[0-9][A-Za-z][A-Za-z])$/
        return pattern.test(postcode);
    }

    isValidPhone(phonenumber) {
        if (phonenumber.length == 0) {
            return false;
        }

        const validNumbers = '0123456789 +()';
        const number = '0123456789';
        let singleChar = '';
        let plusCount = 0;
        let lengthCount = 0;

        //Count plus symbol, only one allowed
        for (let k = 0; k < number.length; k++) {
            singleChar = number.charAt(k);

            if (singleChar == '+') {
                plusCount++;
            }
        }

        if (plusCount > 1) {
            return 'invalid';
        }

        //Check for numbers only
        for (let k = 0; k < phonenumber.length; k++) {
            singleChar = phonenumber.charAt(k);

            if (validNumbers.indexOf(singleChar) == -1) {
                return 'invalid';
            }
        }

        //Check length is 10+
        for (let k = 0; k < phonenumber.length; k++) {
            singleChar = phonenumber.charAt(k);

            if (number.indexOf(singleChar) >= 0) {
                lengthCount++;
            }
        }

        if (lengthCount < 9) {
            return 'short';
        }

        return true;
    }

    isValidPassword(password) {
        if (password.length < 8) {
            return false;
        }
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(password);
    }

    // Gets the type of event to bind to, to detect a change
    getEventType(element) {
        let tagName = this.tagName;
        let inputType = this.inputType;
        if (typeof element !== 'undefined') {
            tagName = this.getTagName(element);
            inputType = this.getInputType(element);
        }
        if (tagName == 'select' || (tagName == 'input' && (inputType == 'checkbox' || inputType == 'radio'))) {
            return 'change';
        }
        if (tagName == 'input' || tagName == 'textarea') {
            return 'input';
        }
        return false;
    }

    unbindEvents() {
        // If it's a validate-if, then no events are attached
        if (this.target.getAttribute('data-validate-if')) {
            return false;
        }

        // If it's a material form, we need to add an active class when a field has a value
        // So we trigger an event on focusout to handle this
        if (this.form.hasOverlayingLabels && !this.form.vueForm) {
            this.targetJquery.off('focusout.ContactFormValidator');
        }

        // See if we have a method called isValid_whatever, and only attach an event if we do
        let methodName = this.target.dataset.validate;
        if (typeof this['isValid_' + methodName] !== 'undefined') {
            // The group event needs to bind on the group elements, not the group container
            if (methodName == 'group') {
                let groupElements = this.getGroupElements();
                if (groupElements == false) {
                    return false;
                }
                const self = this;
                groupElements.each(function() {
                    // Determine the event initiation based on element type
                    const eventType = self.getEventType(this);

                    // Bind the relevant eventType to this form element inside the group
                    self.targetJquery.off(eventType + '.ContactFormValidator');

                    // When focus is lost on an element, we want to validate it
                    self.targetJquery.off('blur.ContactFormValidator');
                });
                // Return out of the method to avoid binding anything extra
                return true;
            }

            // Determine the event initiation based on element type
            const eventType = this.getEventType();
            // Unbind the relevant eventType
            this.targetJquery.off(eventType + '.ContactFormValidator');
            this.targetJquery.off('blur.ContactFormValidator');
            this.targetJquery.off(eventType + '.TagManagerEvents');
        }

    }

    // Binds the validation event for this element
    bindEvents() {
        // If it's a validate-if, then no events are attached
        if (this.target.getAttribute('data-validate-if')) {
            return false;
        }

        // See if we have a method called isValid_whatever, and only attach an event if we do
        const methodName = this.target.dataset.validate;
        if (typeof this['isValid_' + methodName] == 'undefined') {
            return;
        }
        // The group event needs to bind on the group elements, not the group container
        if (methodName == 'group') {
            let groupElements = this.getGroupElements();
            if (groupElements == false) {
                return false;
            }
            const self = this;
            groupElements.each(function() {
                // Determine the event initiation based on element type
                let eventType = self.getEventType(this);

                // Bind the relevant eventType to this form element inside the group
                self.targetJquery.off(eventType + '.ContactFormValidator').on(eventType + '.ContactFormValidator', function (e, f) {
                    // If we have a do_not_validate flag, then don't attach an event. This is mostly used as a way to prevent elements from validating when changed via JS. i.e. dealer select
                    if (typeof f !== 'undefined' && f == 'do_not_validate') {
                        return true;
                    }
                    // Call isValid on this element, which runs all of the validation checks, but pass in true for the skipDisplay flag
                    // We're not displaying errors because only the outer group container should be rendering the error
                    self.isValid(true);
                });

                // When focus is lost on an element, we want to validate it
                self.targetJquery.off('blur.ContactFormValidator').on('blur.ContactFormValidator', function (e, f) {
                    // Call isValid on this element, which runs all of the validation checks and renders/clears errors as needed
                    self.isValid();
                });
            });
            // Return out of the method to avoid binding anything extra
            return true;
        }

        // Determine the event initiation based on element type
        let eventType = this.getEventType();
        // For radio buttons, we need to bind the events to every radio button, not just the first one
        if (methodName == 'radio') {
            this.form.getForm()[0].querySelectorAll('input[name="'+this.target.getAttribute('name')+'"]').forEach(element => {
                const jqueryElement = $(element);
                // Bind the relevant eventType
                jqueryElement.off(eventType + '.ContactFormValidator').on(eventType + '.ContactFormValidator', (e, f) => {
                    // If we have a do_not_validate flag, then don't attach an event. This is mostly used as a way to prevent elements from validating when changed via JS. i.e. dealer select
                    if (typeof f !== 'undefined' && f == 'do_not_validate') {
                        return true;
                    }
                    // Call isValid on this element, which runs all of the validation checks and renders/clears errors as needed
                    this.isValid();
                });

                // When focus is lost on an element, we want to validate it
                jqueryElement.off('blur.ContactFormValidator').on('blur.ContactFormValidator', function (e, f) {
                    // Call isValid on this element, which runs all of the validation checks and renders/clears errors as needed
                    this.isValid();
                }.bind(this));
            });
            return;
        }

        // Bind the relevant eventType
        this.targetJquery.off(eventType + '.ContactFormValidator').on(eventType + '.ContactFormValidator', (e, f) => {
            // If we have a do_not_validate flag, then don't attach an event. This is mostly used as a way to prevent elements from validating when changed via JS. i.e. dealer select
            if (typeof f !== 'undefined' && f == 'do_not_validate') {
                return true;
            }
            // Call isValid on this element, which runs all of the validation checks and renders/clears errors as needed
            this.isValid();
        });

        // When focus is lost on an element, we want to validate it
        this.targetJquery.off('blur.ContactFormValidator').on('blur.ContactFormValidator', function (e, f) {
            // Call isValid on this element, which runs all of the validation checks and renders/clears errors as needed
            this.isValid();
        }.bind(this));
    }

    bindTagManagerEvents() {
        const self = this;
        const eventType = this.getEventType();
        if (this.getInputType() == 'radio') {
            const allRadioButtons = this.form.getForm()[0].querySelectorAll("input[name='" + this.target.getAttribute('name') + "']");
            allRadioButtons.forEach(radioButton => {
                $(radioButton).off(eventType + '.TagManagerEvents').on(eventType + '.TagManagerEvents', function (e, f) {
                    if (typeof f !== 'undefined' && f == 'do_not_validate') {
                        return true;
                    }
                    customEvent('Form Input', self.form.niceFormName, this.getAttribute('name'));
                    const allRadioButtons = self.form.getForm()[0].querySelectorAll("input[name='" + this.getAttribute('name') + "']");
                    allRadioButtons.forEach(radioButton => {
                        $(radioButton).off(eventType + '.TagManagerEvents');
                    });
                });
            })
            return;
        }
        this.targetJquery.off(eventType + '.TagManagerEvents').on(eventType + '.TagManagerEvents', function (e, f) {
            if (typeof f !== 'undefined' && f == 'do_not_validate') {
                return true;
            }
            customEvent('Form Input', self.form.niceFormName, this.getAttribute('name'));
            $(this).off(eventType + '.TagManagerEvents');
        });
    }
}